import React from 'react';
import RatingBox from '../Rating/RatingBox';
import Modal from "./Modal";
import {Link} from "react-router-dom";
import styles from './Modal.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare, faExclamation } from "@fortawesome/free-solid-svg-icons";
import DateService from "../../services/DateService";

const ModalAlert = ({ data, onClose }) => {
    const formatDate = (date) => {
        const fromNow = DateService.fromNow(date);
        return fromNow.charAt(0).toUpperCase() + fromNow.slice(1);
    };

    const renderLateSeances = () => {
        return data.seances.map((seance, index) => {
            return (
                <div key={index} className={styles.lateSeanceContainer}>
                    <Link className={styles.lateSeanceLink} to={seance.link} onClick={onClose}>
                        <div>
                            <span className={styles.lateSeanceDate}>{formatDate(seance.date)}</span>
                            <span className={styles.lateSeanceLabel}>{seance.titre}</span>
                        </div>

                        <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
                    </Link>
                </div>
            );
        });
    }

    return (
        <Modal onClose={onClose}>
            <div className="modal_content">
                <h2 className={styles.lateSeanceTitle}>
                    <FontAwesomeIcon icon={faExclamation} className={styles.iconeTitle} />
                    <span>ATTENTION</span>
                </h2>

                <p>{data.message}</p>
                {data.seances && renderLateSeances()}
            </div>
        </Modal>
    );
};

export default ModalAlert;
